import {
  GetPolicyResponse,
  SourceSystem,
} from '@aaa-ncnu-ie/mypolicy-api-policies';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getPolicyDetails = async (
  policyNumber?: string,
  sourceSystem?: SourceSystem
) => {
  if (!policyNumber || !sourceSystem) {
    return Promise.reject(new Error('Missing policyNumber or sourceSystem'));
  }

  const { data } = await axios.get<GetPolicyResponse>(
    `${import.meta.env.VITE_POLICIES_API_URL}/v1/policies/${policyNumber}`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      params: { sourceSystem },
    }
  );

  return data;
};

// sourceSystem comes from the policies list, so the query stays disabled
// until that lookup resolves instead of firing a PAS-default request first
export const usePolicyDetailsQuery = (
  policyNumber?: string,
  sourceSystem?: SourceSystem
) =>
  useQuery({
    queryKey: ['policyDetails', policyNumber, sourceSystem],
    queryFn: () => getPolicyDetails(policyNumber, sourceSystem),
    enabled: !!policyNumber && !!sourceSystem,
  });
